<template>
  <div class="base-box">
    <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft" />
    <div style="text-align:center; padding:30px 0;position: fixed;top: 1.5rem;z-index: 999;">
      <van-overlay :show="loading" :lock-scroll="true" style="z-index: 888;">
        <van-loading color="#fff" size="24px" vertical style="z-index: 999;margin-top: 50%;">正在提交中...</van-loading>
      </van-overlay>
    </div>
    <p>标注<span style="color: red"> “ * ” </span>的填写项为必填项,如空缺则不能完成注册。</p>
    <div class="fontBox">
      <!-- <div style="margin-top:20px">
            <table>
                <thead>
                <tr>
                    <td>关注分会</td>
                    <td>分会职务</td>
                </tr>
                </thead>
            </table>
            <memberPostTable ref="memberPostTable" :memberId="infos.id"></memberPostTable>
        </div> -->
      <!-- <advanced-form ref="advForm" :initFields="fields" :formData.sync="params" :allDictionary="allDictionary"></advanced-form> -->
      <advanced-form ref="advForm" :initFields="fields" :formData.sync="member" :allDictionary="allDictionary"
        :allAddress="cityList" :branchsList="branchsList" :customDataList="customDataList"></advanced-form>
    </div>
    <div class="buttonBox" v-if="fields.length>0">
      <template v-if="member.memberStatus == 4 || member.step == 1 || member.memberStatus == null ||
      this.member.memberStatus==15||this.member.memberStatus ==14||this.member.memberStatus ==16">
        <van-button type="primary" size="large" plain @click="saveGroup()">暂存</van-button>
        <van-button type="primary" size="large" @click="save()">提交</van-button>
      </template>
      <template v-else>
        <van-button type="primary" size="large" @click="save()">保存</van-button>

      </template>
      <!-- <van-button type="primary" size="large" plain @click="saveGroup()">保存</van-button>
      <van-button type="primary" size="large" @click="save()">提交</van-button> -->
    </div>
  </div>
</template>


<script>
  import memberPostTable from "../../components/memberPostTable";
  import {
    getBranchs,
    getGroupRegisterSetting,
    saveGroupMemberSz,
  } from "@/api/dictionary";
  import vHead from "../../components/Subhead.vue";
  import {
    registerGroupEdit,
  } from "@/api/login";
  import {
    Field,
    Button,
    Toast,
    NavBar,
    Checkbox,
    CheckboxGroup,
    Dialog,
    Overlay, Loading
  } from "vant";
  import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
  import AdvancedForm from "../../components/AdvancedForm.vue";

  export default {
    data() {
      return {
        loading: false,
        resultProductType: [],
        result: [],
        title: "入会申请表",
        columns: [],
        items: [],
        infos: {},
        // fields: [
        //   {
        //       "id": "bb791ee4-dd0d-44af-ac67-7ada359cd109",
        //       "tid": "0",
        //       "schemaId": "33b41c2a-d3df-4383-96bd-506edd4f852b",
        //       "field": null,
        //       "fieldCaption": "单位类型",
        //       "fieldType": null,
        //       "fieldLength": null,
        //       "editorType": 9,
        //       "description": "单位类型",
        //       "dictionaryId": null,
        //       "seq": 1,
        //       "display": 1,
        //       "readonly": 0,
        //       "nullable": 0,
        //       "checkRule": null,
        //       "displayFormat": null,
        //       "editorWidth": 4,
        //       "editorGroup": 1
        //   },
        //   {
        //       "id": "9e5969b9-9e8c-4070-b765-0e60f4e77f69",
        //       "tid": "0",
        //       "schemaId": "33b41c2a-d3df-4383-96bd-506edd4f852b",
        //       "field": "memberType",
        //       "fieldCaption": "单位类型",
        //       "fieldType": 4,
        //       "fieldLength": 11,
        //       "editorType": 4,
        //       "description": "单位类型",
        //       "dictionaryId": "GROUP_TYPE",
        //       "seq": 2,
        //       "display": 1,
        //       "readonly": 0,
        //       "nullable": 0,
        //       "checkRule": null,
        //       "displayFormat": null,
        //       "editorWidth": 6,
        //       "editorGroup": 1
        //   },
        //   {
        //       "id": "51b5ccd7-1d8d-4730-b172-4e39f666c31e",
        //       "tid": "0",
        //       "schemaId": "33b41c2a-d3df-4383-96bd-506edd4f852b",
        //       "field": "name",
        //       "fieldCaption": "真实姓名",
        //       "fieldType": 5,
        //       "fieldLength": 64,
        //       "editorType": 1,
        //       "description": "真实姓名",
        //       "dictionaryId": null,
        //       "seq": 7,
        //       "display": 1,
        //       "readonly": 0,
        //       "nullable": 0,
        //       "checkRule": null,
        //       "displayFormat": null,
        //       "editorWidth": 1,
        //       "editorGroup": 1
        //   },
        //   {
        //       "id": "7e7dd7e8-e8ef-43fe-b11b-c8c69766837b",
        //       "tid": "0",
        //       "schemaId": "33b41c2a-d3df-4383-96bd-506edd4f852b",
        //       "field": "businessScope",
        //       "fieldCaption": "业务范围",
        //       "fieldType": 5,
        //       "fieldLength": null,
        //       "editorType": 13,
        //       "description": "业务范围",
        //       "dictionaryId": "BUSINESS_SCOPE",
        //       "seq": 15,
        //       "display": 1,
        //       "readonly": 0,
        //       "nullable": 0,
        //       "checkRule": null,
        //       "displayFormat": null,
        //       "editorWidth": 4,
        //       "editorGroup": 1
        //   }
        // ],
        // request: {
        //     memberType:"请选择单位类型",//
        //     recommendUnitId:'请选择推荐单位',
        //     name: "请输入单位会员名称",
        //     registrationFullAddress: "请输入住所",
        //     // registeredCapital: "请输入注册资本金",
        //     researcherCount: "请输入职工人数",
        //     fullAddress: "请输入通讯地址",
        //     zipcode: "请输入邮政编码",
        //     introduction: "请输入单位简介",
        //     //pic:'请输入负责人名称',
        //     code:'请输入统一社会信用代码',
        //     //introduction: "请输入单位简介",
        //     fullAddress:'请输入注册地址',
        //     //unitProperties:'请输入单位性质',
        //      mobile:'请输入联系人手机号',
        //      email:'请输入联系人邮箱',
        //      representName:'请输入联系人姓名',
        //      // representPosition:'请输入联系人职务',
        //     //address:'请输入联系人地址',
        //     // zipcode:'请输入联系人邮政编码',
        //     //telephone:'请输入联系人办公电话',
        //     introduction: "请输入单位简介",
        //     corporation: "请输入法人名称",
        //     corporationPosition: "请输入法人职务",
        //     corporationMobile: "请输入法人手机号",
        //     //corporationOicq: "请输入法人微信/QQ",
        //     corporationEmail: "请输入法人邮箱",
        // },
        params: {
          name: "",
          code: "",
          corporation: "",
          registrationFullAddress: "",
          historyMemberNo: "",
          businessScope: "",
          researcherCount: "",
          representPosition: "",
          corporationPosition: "",
          representName: "",
          website: "",
          recommendUnitId: null,
          foundDate: new Date(),
          memberType: null,
          introduction: "",
          mobile: "",
          corporationEmail: "",
          corporationOicq: "",
          email: "",
          corporationMobile: "",
          fax: "",
          pgndArea: "",
          openArea: "",
          unitProperties: "",
          telephone: "",
          zipcode: "",
          address: "",
          fullAddress: "",
        },
        branchList: [],
        customDataList: {},
        member: {},
        fields: [],
      };
    },
    components: {
      vHead,
      [Field.name]: Field,
      [Button.name]: Button,
      [Toast.name]: Toast,
      [NavBar.name]: NavBar,
      memberPostTable,
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup,
      AdvancedForm,
      [Dialog.name]: Dialog,
      [Loading.name]: Loading,
      [Overlay.name]: Overlay,
    },
    computed: {
      ...mapState(["branchsList", "userInfo", "cityList"]),
      ...mapGetters(["allDictionary", "GROUP_TYPE"]),
      //会员类型名称
      memberName() {
        let id = this.params.memberType;
        if (!id) {
          return "内容";
        } else {
          let obj = this.memberTypeList.find((item) => item.memberType === id);
          return obj.dueName;
        }
      },
      gender() {
        let id = this.params.gender;
        if (!id && id !== 0) {
          return "内容";
        } else {
          let obj = this.GENDER.find((item) => item.value === id);
          if (obj) return obj.name;
        }
      },
      foundDate() {
        let time = this.params.foundDate;
        if (!time) {
          return;
        }
        return this.dateFormat(time);
      },
      sheng() {
        return this.cityList.filter((item) => {
          return item.level === 1;
        });
      },
      shi: function () {
        return this.cityList.filter((item) => {
          return item.parentId === this.sheng[0].id;
        });
      }
    },
    methods: {
      ...mapActions([
        "getDictionaryList",
        "getMemberTypeList",
        "getBranchsList",
        "getZhiChengList",
        "getCityList",
      ]),
      ...mapMutations(["setMemberInfo"]),
      onClickLeft() {
        if (!this.member.memberNo && !this.member.memberStatus) {
          Dialog.alert({
            title: '提示',
            message: '请您填写并提交入会申请表！',
          }).then(() => {
            // on close
          });
          return;
        }
        this.$router.push({ name: "MemberCenter" });
      },
      dateFormat(timeStamp) {
        // var datea = new Date(timeStamp.replace(/-/g, '/'));
        let year = new Date(timeStamp).getFullYear();
        let month =
          new Date(timeStamp).getMonth() + 1 < 10
            ? "0" + (new Date(timeStamp).getMonth() + 1)
            : new Date(timeStamp).getMonth() + 1;
        let date =
          new Date(timeStamp).getDate() < 10
            ? "0" + new Date(timeStamp).getDate()
            : new Date(timeStamp).getDate();
        return year + "-" + month + "-" + date;
      },
      save() {
        let params = this.member;
        let valid = this.$refs["advForm"].validateForm();
        if (!valid) {
          return;
        }
        params.foundDate = this.dateFormat(params.foundDate);
        if (params.foundDate) {
          params.foundDate = params.foundDate.substr(0, 10);
        }
        if (params.expiryDate) {
          params.expiryDate = params.expiryDate.substr(0, 10);
        }
        if (params.corporationBirthday) {
          params.corporationBirthday = params.corporationBirthday.substr(0, 10);
        }
        let result = this.checkSocialCreditCode(params.code);
        if (!result) {
          Toast.fail("请输入正确的社会统一信用码");
          return;
        }
        this.loading = true
        registerGroupEdit(params).then((res) => {
          if (res.success) {
            this.loading = false
            this.$router.push({ name: "MemberCenter" });
          } else {
            this.loading = false
            if (res.message && res.message == '该单位名称已经注册') {
              Toast.fail("该单位名称已经注册");
            }else {
              Toast.fail("保存失败");
            }
          }
        });
      },
      saveGroup() {
        let params = this.member;
        params.foundDate = this.dateFormat(params.foundDate);
        if (params.foundDate) {
          params.foundDate = params.foundDate.substr(0, 10);
        }
        if (params.expiryDate) {
          params.expiryDate = params.expiryDate.substr(0, 10);
        }
        if (params.corporationBirthday) {
          params.corporationBirthday = params.corporationBirthday.substr(0, 10);
        }
        saveGroupMemberSz(params).then((res) => {
          if (res.success) {
            Toast.success("保存成功");
            // this.$router.push({ name: 'MemberCenter'});
          } else {
            if (res.message && res.message == '该单位名称已经注册') {
              Toast.fail("该单位名称已经注册");
            }else {
              Toast.fail("保存失败");
            }
          }
        });
      },
      checkSocialCreditCode(Code) {
        var patrn = /^[0-9A-Z]+$/;
        if (Code.length != 18 || patrn.test(Code) == false) {
          return false;
        } else {
          var Ancode;
          var Ancodevalue;
          var total = 0;
          var weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];
          var str = "0123456789ABCDEFGHJKLMNPQRTUWXY";
          for (var i = 0; i < Code.length - 1; i++) {
            Ancode = Code.substring(i, i + 1);
            Ancodevalue = str.indexOf(Ancode);
            total = total + Ancodevalue * weightedfactors[i];
          }
          var logiccheckcode = 31 - (total % 31);
          if (logiccheckcode == 31) {
            logiccheckcode = 0;
          }
          var Str = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y";
          var Array_Str = Str.split(",");
          logiccheckcode = Array_Str[logiccheckcode];
          var checkcode = Code.substring(17, 18);
          if (logiccheckcode != checkcode) {
            return false;
          }
          return true;
        }
      },
      getFields() {
        getGroupRegisterSetting().then((resp) => {
          if (resp.success) {
            this.fields = resp.result;
          } else {
            this.$message.error(resp.message);
          }
        });
      },
    },

    mounted() {
      var obj = window.localStorage.getItem("userInfo");
      this.member = JSON.parse(obj);
      this.getFields();
      getBranchs().then((res) => {
        if (res.success) {
          res.result.forEach((itm) => (itm.value = itm.code));
          this.customDataList["recommendUnitId"] = res.result;
          this.customDataList["concernUnitId"] = res.result;
          this.branchList = res.result;
        }
      });
      this.getBranchsList();
      this.getDictionaryList();
      this.getCityList();
      window.scrollTo(0, 0);
    },
  };
</script>

<style lang="less" scoped>
  .buttonBox {
    background: #f3f6fb;
    padding: 20px 10px;
    display: flex;

    button {
      margin: 0 10px;
    }
  }

  .base-item {
    margin-top: 10px;
  }

  .nextBtn {
    margin-top: 35px;
    height: 45px !important;
    line-height: 45px;
  }

  .base-box>p {
    font-size: 13px;
    color: #999;
    margin: 20px 0 8px 0;
    margin-left: 20px;
  }

  .fontBox {
    font-size: 14px;
    padding: 0 18px 0;
    //   border-top: #f3f6fb solid 10px;
    color: #323233;
    background: #fff;
  }

  .fontBox thead {
    background: #f2f2f2;
  }

  .fontBox table td {
    font-size: 15px;
    margin: 0;
    color: #000;
    padding: 10px 0;
  }

  table {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    border-spacing: 1;
    border-spacing: 0;
  }

  table td {
    word-break: break-all;
    word-wrap: break-word;
    border: 1px solid #dfdfdf;
  }
</style>